import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationAnalyticsService } from '../navigation-analytics.service';

@Component({
  selector: 'app-page-view-tracker',
  template: '',
})
export class PageViewTrackerComponent {
  constructor(
    private router: Router,
    private service: NavigationAnalyticsService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.service.reportPageView(event);
      }
    });
  }
}
